export enum Padding {
  Small = "8px",
  Medium = "16px",
  Large = "32px",
}
